import { ComponentAPI } from '@philips-internal/oswald-ui-core';
export default class ApprovalItemDetailsAPI extends ComponentAPI {
    setData(data) {
        this.setState({ ...data });
    }
}
//# sourceMappingURL=approval-item-details-api.js.map